enum LenderName {
    HUNTINGTON_NATIONAL_BANK = 'Huntington National Bank',
    ROADRUNNER_FINANCIAL = 'Roadrunner Financial',
}

export default LenderName
